// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"07e3f17d","539":"be171156","640":"b07c8381","653":"9ffadb48","884":"8797aab2","901":"e54d8b45","950":"12138667","959":"b21e46aa","961":"22fef70f"}[chunkId] + ".chunk.js";
};